import React from 'react';
import { Link } from 'react-router-dom';
import { FaGlobe, FaEnvelope, FaUsers, FaPalette, FaHeart, FaUserShield, FaFlag, FaUserSecret, FaRandom, FaForward, FaMapMarkerAlt } from 'react-icons/fa';
import { Card } from '../components/ds/core/Card';
import { Badge } from '../components/ds/core/Badge';
import AdSlot from '../components/AdSlot';
import './AboutView.css';

function AboutView() {
  return (
    <div className="about-view">
      <div className="about-container">
        <div className="about-header">
          <Badge tone="brand" icon={<FaGlobe />}>About Yapp</Badge>
          <h1>Say hi to the whole planet</h1>
          <p>Connect with people around the world through an interactive globe experience.</p>
        </div>

        <div className="about-content">
          <Card variant="glass" padding="lg" className="about-section about-intro" style={{ background: '#e6e7eb', color: 'var(--text-body)', border: '1px solid var(--border-subtle)', boxShadow: 'var(--shadow-md)', backdropFilter: 'none' }}>
            <h2>What is Yapp?</h2>
            <p>
              Yapp is a unique social platform that combines geography and social networking.
              Explore the world, connect with people from different countries
              as you expand your global network.
            </p>
          </Card>

          <div className="about-section">
            <h2 className="about-section-title">Key Features</h2>
            <div className="features-grid">
              <Card variant="glass" padding="lg" hover className="feature-card" style={{ background: '#e6e7eb', color: 'var(--text-body)', border: '1px solid var(--border-subtle)', boxShadow: 'var(--shadow-md)', backdropFilter: 'none' }}>
                <div className="feature-icon">
                  <FaGlobe />
                </div>
                <h3>Interactive Globe</h3>
                <p>
                  Explore an interactive 3D globe showing users from around the world.
                </p>
              </Card>

              <Card variant="glass" padding="lg" hover className="feature-card" style={{ background: '#e6e7eb', color: 'var(--text-body)', border: '1px solid var(--border-subtle)', boxShadow: 'var(--shadow-md)', backdropFilter: 'none' }}>
                <div className="feature-icon">
                  <FaRandom />
                </div>
                <h3>Random Matching</h3>
                <p>
                  Send a message to the world and get matched randomly with another user.
                  Start a conversation with someone new from anywhere on the globe.
                </p>
              </Card>

              <Card variant="glass" padding="lg" hover className="feature-card" style={{ background: '#e6e7eb', color: 'var(--text-body)', border: '1px solid var(--border-subtle)', boxShadow: 'var(--shadow-md)', backdropFilter: 'none' }}>
                <div className="feature-icon">
                  <FaMapMarkerAlt />
                </div>
                <h3>Country Visibility</h3>
                <p>
                  See which country your chat partner is messaging from. Discover where
                  in the world your new connections are located.
                </p>
              </Card>

              <Card variant="glass" padding="lg" hover className="feature-card" style={{ background: '#e6e7eb', color: 'var(--text-body)', border: '1px solid var(--border-subtle)', boxShadow: 'var(--shadow-md)', backdropFilter: 'none' }}>
                <div className="feature-icon">
                  <FaEnvelope />
                </div>
                <h3>Real-time Messaging</h3>
                <p>
                  Send messages to users you've connected with. Have conversations with people
                  from different cultures and backgrounds in real-time.
                </p>
              </Card>

              <Card variant="glass" padding="lg" hover className="feature-card" style={{ background: '#e6e7eb', color: 'var(--text-body)', border: '1px solid var(--border-subtle)', boxShadow: 'var(--shadow-md)', backdropFilter: 'none' }}>
                <div className="feature-icon">
                  <FaUserSecret />
                </div>
                <h3>Anonymous Connections</h3>
                <p>
                  Connect with strangers anonymously. Your identity stays private until you
                  decide to reveal it by becoming friends.
                </p>
              </Card>

              <Card variant="glass" padding="lg" hover className="feature-card" style={{ background: '#e6e7eb', color: 'var(--text-body)', border: '1px solid var(--border-subtle)', boxShadow: 'var(--shadow-md)', backdropFilter: 'none' }}>
                <div className="feature-icon">
                  <FaForward />
                </div>
                <h3>Skip Feature</h3>
                <p>
                  Not feeling the conversation? Use the skip feature to end your current
                  anonymous chat and move on to meet someone new.
                </p>
              </Card>

              <Card variant="glass" padding="lg" hover className="feature-card" style={{ background: '#e6e7eb', color: 'var(--text-body)', border: '1px solid var(--border-subtle)', boxShadow: 'var(--shadow-md)', backdropFilter: 'none' }}>
                <div className="feature-icon">
                  <FaUsers />
                </div>
                <h3>Friend System</h3>
                <p>
                  Send and receive friend requests. Build your global network by connecting
                  with users from different countries and regions.
                </p>
              </Card>

              <Card variant="glass" padding="lg" hover className="feature-card" style={{ background: '#e6e7eb', color: 'var(--text-body)', border: '1px solid var(--border-subtle)', boxShadow: 'var(--shadow-md)', backdropFilter: 'none' }}>
                <div className="feature-icon">
                  <FaPalette />
                </div>
                <h3>Theme Customization</h3>
                <p>
                  Personalize your experience with custom themes. Choose from preset themes or
                  create your own color scheme for the globe, background, and interface.
                </p>
              </Card>

              <Card variant="glass" padding="lg" hover className="feature-card" style={{ background: '#e6e7eb', color: 'var(--text-body)', border: '1px solid var(--border-subtle)', boxShadow: 'var(--shadow-md)', backdropFilter: 'none' }}>
                <div className="feature-icon">
                  <FaHeart />
                </div>
                <h3>Likes System</h3>
                <p>
                  Show appreciation for other users with likes. Track your received likes
                  in your profile and see how popular you are in the community.
                </p>
              </Card>

              <Card variant="glass" padding="lg" hover className="feature-card" style={{ background: '#e6e7eb', color: 'var(--text-body)', border: '1px solid var(--border-subtle)', boxShadow: 'var(--shadow-md)', backdropFilter: 'none' }}>
                <div className="feature-icon">
                  <FaUserShield />
                </div>
                <h3>Privacy Controls</h3>
                <p>
                  Block users you don't want to interact with. Manage your blocked users
                  list from your profile settings for a safe experience.
                </p>
              </Card>

              <Card variant="glass" padding="lg" hover className="feature-card" style={{ background: '#e6e7eb', color: 'var(--text-body)', border: '1px solid var(--border-subtle)', boxShadow: 'var(--shadow-md)', backdropFilter: 'none' }}>
                <div className="feature-icon">
                  <FaFlag />
                </div>
                <h3>Report System</h3>
                <p>
                  Report inappropriate behavior or content. Help keep the community safe
                  and respectful for all users around the world.
                </p>
              </Card>
            </div>
          </div>

          <div className="about-section">
            <h2 className="about-section-title">How to Get Started</h2>
            <Card variant="glass" padding="lg" className="steps-card" style={{ background: '#e6e7eb', color: 'var(--text-body)', border: '1px solid var(--border-subtle)', boxShadow: 'var(--shadow-md)', backdropFilter: 'none' }}>
              <ol className="steps-list">
                <li>
                  <strong>Create an Account:</strong> Sign up with your email to start exploring the platform.
                </li>
                <li>
                  <strong>Start a Conversation:</strong> Click "Send to a random stranger" on the globe to match with someone from anywhere in the world.
                </li>
                <li>
                  <strong>Chat Anonymously:</strong> Have conversations while staying anonymous. You can see their country but not their identity.
                </li>
                <li>
                  <strong>Skip or Connect:</strong> Use the skip button to find someone new, or send a friend request to reveal identities and keep in touch.
                </li>
                <li>
                  <strong>Customize Your Experience:</strong> Visit your profile to change themes and personalize your settings.
                </li>
              </ol>
            </Card>
          </div>

          <Card variant="glass" padding="lg" className="about-section about-safety" style={{ background: '#e6e7eb', color: 'var(--text-body)', border: '1px solid var(--border-subtle)', boxShadow: 'var(--shadow-md)', backdropFilter: 'none' }}>
            <h2>Safety &amp; Community Guidelines</h2>
            <p>
              Yapp is committed to providing a safe and welcoming environment for all users.
              Please be respectful, kind, and considerate in your interactions. Use the block
              and report features if you encounter any inappropriate behavior.
            </p>
          </Card>

          <div className="about-section" style={{ textAlign: 'center', marginTop: '1rem', display: 'flex', justifyContent: 'center', gap: '1.25rem' }}>
            <Link to="/privacy" className="login-switch-link">Privacy Policy</Link>
            <Link to="/contact" className="login-switch-link">Contact Us</Link>
          </div>

          <AdSlot format="horizontal" style={{ maxWidth: 970 }} />
        </div>
      </div>
    </div>
  );
}

export default AboutView;
